import { lightColors, secondaryColors } from '@tryhackme/thm-ui-components';
import styled, { createGlobalStyle } from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
  z-index: 1;
`;

export const StyledDescription = styled.p<{ $isDarkMode?: boolean }>`
  margin: 0.8rem 0 4.6rem;
  color: ${({ $isDarkMode }) => ($isDarkMode ? secondaryColors.grey[400] : secondaryColors.grey[800])};
`;

export const StyledFooterWrapper = styled.div<{ $isFormSubmitted?: boolean; $isDarkMode?: boolean }>`
  & footer {
    position: ${({ $isFormSubmitted }) => ($isFormSubmitted ? 'relative' : 'absolute')};
    bottom: ${({ $isFormSubmitted }) => ($isFormSubmitted ? '0' : '1.6rem')};
    left: 0;
    right: 0;
    border: none;
    margin-right: ${({ $isFormSubmitted }) => ($isFormSubmitted ? '0' : '16rem')};
    z-index: 1;

    @media (max-width: ${({ theme }) => theme.sizes.md}) {
      bottom: 0.5rem;
      padding-top: ${({ $isFormSubmitted }) => ($isFormSubmitted ? '0' : '8rem')};
      margin-right: 0;
    }

    & button {
      background-color: ${({ $isDarkMode }) => ($isDarkMode ? `rgb(21, 28, 43)` : lightColors.background.light)};

      @media (max-width: ${({ theme }) => theme.sizes.md}) {
        margin-right: 0;
        width: 100%;
      }
    }
  }
`;

export const StyledFormWrapper = styled.div`
  position: relative;
  z-index: 1;
`;

export const RecaptchaGlobalStyles = createGlobalStyle`
  /* Ensure Google reCAPTCHA modal and iframe can be interacted with */
  iframe[src*="google.com/recaptcha"],
  iframe[src*="recaptcha"],
  div[style*="z-index: 2147483647"],
  div[style*="z-index:2147483647"] {
    z-index: 2147483647 !important;
    pointer-events: auto !important;
  }

  /* Ensure reCAPTCHA overlay is above modal overlay (which is z-index: 1000) */
  body > div[style*="z-index"] {
    &:has(iframe[src*="recaptcha"]) {
      z-index: 2147483647 !important;
      pointer-events: auto !important;
    }
  }
`;
